
export default {
    name: "ResponseError",
    props: {
        request: {
            type: Object,
            default: null,
        },
    },
    computed: {
        error() {
            return this.request?.error
        },
    },
}
